import PageEditor from './PageEditor';

export default PageEditor;
